// extracted by mini-css-extract-plugin
export default {"button":"Button_button__xoFkt","heedful":"Button_heedful__PydF1","large":"Button_large__P0u5b"};